import Image from "next/image";

type TextbookUploadedCardProps = {
  copy: {
    number: string;
    title: string;
    image: {
      src: string;
      alt: string;
      width: number;
      height: number;
    };
  };
  compact?: boolean;
  className?: string;
};

export function TextbookUploadedCard({ copy, compact = false, className = "" }: TextbookUploadedCardProps) {
  return (
    <article
      className={`relative z-10 flex min-w-0 flex-col rounded-[24px] border border-slate-200 bg-white p-4 shadow-[0_24px_70px_-45px_rgba(15,23,42,0.45)] ring-1 ring-slate-950/[0.02] sm:p-5 ${compact ? "" : "min-h-[430px]"} ${className}`}
    >
      <div className="flex items-center gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-100 text-sm font-bold text-[#08A62F]">
          {copy.number}
        </span>
        <h3 className="text-base font-bold text-slate-950 sm:text-[17px]">{copy.title}</h3>
      </div>

      <div className="mt-4">
        <div className="overflow-hidden rounded-[18px] border border-slate-200 bg-slate-50 p-2 shadow-inner">
          <Image
            src={copy.image.src}
            alt={copy.image.alt}
            width={copy.image.width}
            height={copy.image.height}
            className={`w-full rounded-[14px] border border-slate-200 bg-white object-contain shadow-sm ${compact ? "max-h-[285px] object-cover object-top" : "h-auto"}`}
            sizes="(min-width: 1024px) 30vw, 100vw"
            priority={false}
          />
        </div>
      </div>
    </article>
  );
}
